import React, {useEffect} from 'react';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {RegFormsContextProvider} from '../../components/RegFormsContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import RegFormsTitle from "../../components/RegFormsTitle";
import WarningNoteContainer from "../../components/WarningNoteContainer";
import RegFormsContainer from "../../components/RegFormsContainer";
import RegFormsLinksContainer from "../../components/RegFormsLinksContainer";
import FooterDivider from "../../../../common/components/ui/FooterDivider";
import FooterLogo from '../../../../common/components/ui/FooterLogo';

const RegForms = () => {
  const {setPageTitle} = useGlobalContext();

  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'regForms-page-header'}
        defaultMessage={'Registration forms'}
      />
    ));
  }, []);

  return (
    <RegFormsContextProvider>
      <RegFormsContainer>
        <RegFormsTitle/>
        <WarningNoteContainer/>
        <RegFormsLinksContainer/>
      </RegFormsContainer>
      <FooterDivider/>
      <FooterLogo/>
    </RegFormsContextProvider>
  );
};

export default RegForms;
